<template>
  <div>
    <v-data-table
      :headers="headers" :items="purchases"
      :loading="loading"
      :pagination.sync="filter"
      :total-items="pagination.total"
      :rows-per-page-items="[pagination.perPage]"
      :no-data-text="$t(`purchase.table.noDataText.${serviceType || 'default'}`) + ' ' + $t(`purchase.table.scopes.${scope}`)"
      :no-results-text="$t(`purchase.table.noResultsText.${serviceType || 'default'}`) + ' ' + $t(`purchase.table.scopes.${scope}`)"
      :rows-per-page-text="$t(`purchase.table.rowsPerPageText.${serviceType || 'default'}`) + ' ' + $t(`purchase.table.scopes.${scope}`)"
      :custom-sort="a => a"
      hide-actions>
      <template slot="items" scope="props">
        <td v-if="visible('id')">
          <router-link :to="{ name: 'Purchase', params: { id: props.item.id } }">
            #{{ props.item.id }}
          </router-link>
        </td>
        <td v-if="visible('offer')">
          <purchase-title :purchase="props.item" link></purchase-title>
        </td>
        <td v-if="visible('user')">
          <router-link v-if="props.item.user" :to="{ name: 'User', params: { id: props.item.user.id, tab: 'profile' } }">
            {{ props.item.user.nickname }}
          </router-link>
        </td>
        <td v-if="visible('expert')">
          <router-link :to="{ name: 'Expert', params: { id: props.item.admin.id, tab: 'profile' } }">
            {{ props.item.admin.nickname }}
          </router-link>
        </td>
        <td v-if="visible('payedAt')" class="text-xs-right">
          <date v-if="props.item.payed_at" :value="props.item.payed_at"></date>
          <span v-else><error-code :code="props.item.result_code"></error-code></span>
        </td>
        <td v-if="visible('price')" class="text-xs-right"><purchase-total-price :purchase="props.item"></purchase-total-price></td>
        <td v-if="visible('fees')" class="text-xs-right"><purchase-fees :purchase="props.item"></purchase-fees></td>
        <td v-if="visible('total')" class="text-xs-right"><purchase-received-price :purchase="props.item"></purchase-received-price></td>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-3 pb-3" v-if="pagination.totalPages > 1">
      <v-pagination
        :disabled="loading"
        :value="filter.page"
        @input="value => changePage(value)"
        :length="Math.ceil(pagination.total / pagination.perPage)">
      </v-pagination>
    </div>
  </div>
</template>

<script>
  import Expert from '@/api/currentExpert'
  import { mapGetters } from 'vuex'
  import pagination from '@/mixins/pagination'
  import { Date, ErrorCode } from '@/components/formatters'
  import PurchaseTitle from '@/components/purchase/Title.vue'
  import PurchaseTotalPrice from '@/components/purchase/TotalPrice.vue'
  import PurchaseFees from '@/components/purchase/Fees.vue'
  import PurchaseReceivedPrice from '@/components/purchase/ReceivedPrice.vue'
  export default {
    components: {
      Date,
      ErrorCode,
      PurchaseTitle,
      PurchaseTotalPrice,
      PurchaseFees,
      PurchaseReceivedPrice
    },
    mixins: [
      pagination('skiliko/purchases')
    ],
    props: {
      compact: {
        type: Boolean,
        default: false
      },
      withPriceInformations: {
        type: Boolean,
        default: false
      },
      scope: {
        type: String,
        default: 'all'
      },
      userId: {
        type: Number,
        default: null
      },
      adminId: {
        type: Number,
        default: null
      },
      offerId: {
        type: Number,
        default: null
      },
      serviceType: {
        type: String,
        default: null
      },
      resultCode: {
        type: String,
        default: null
      },
      period: {
        type: Array,
        default: () => [null, null]
      },
      periodFilter: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        filter: {
          page: this.page,
          scope: this.scope,
          userId: this.userId,
          adminId: this.adminId,
          offerId: this.offerId,
          serviceType: this.serviceType,
          resultCode: this.resultCode,
          dateFilter: ((this.period[0] || this.period[1]) && this.periodFilter) || null,
          from: this.period[0],
          to: this.period[1]
        }
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform',
        currentUser: 'skiliko/session/currentUser'
      }),
      headers () {
        return [
          { key: 'id', left: true, sortable: false },
          { key: 'offer', left: true, sortable: false },
          { key: 'user', left: true, sortable: false },
          { key: 'expert', left: true, sortable: false },
          { key: 'payedAt', left: false, sortable: false },
          { key: 'price', left: false, sortable: false },
          { key: 'fees', left: false, sortable: false },
          { key: 'total', left: false, sortable: false }
        ]
          .filter(e => this.visible(e.key))
          .map(e => ({
            ...e,
            text: this.$t(`purchase.table.header.${e.key}`)
          }))
      }
    },
    methods: {
      visible (column) {
        switch (column) {
          case 'expert':
            return this.platform.multi_experts && Expert.isAdmin(this.currentUser)
          case 'payedAt':
            return !this.compact
          case 'price':
            return this.withPriceInformations
          case 'fees':
            return this.withPriceInformations && !this.compact
          case 'total':
            return this.withPriceInformations && !this.compact
          default:
            return true
        }
      }
    },
    watch: {
      period () {
        this.filter = {
          ...this.filter,
          dateFilter: ((this.period[0] || this.period[1]) && this.periodFilter) || null,
          from: this.period[0],
          to: this.period[1]
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Table.vue